import { IResourceComponentsProps, useExport, useGetIdentity, useNavigation, useShow, useUpdate } from '@pankod/refine-core'

import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  ShowButton,
  Typography,
  Alert,
  Button,
  Popconfirm,
  Input,
  Divider,
  useTable,
  Form,
  Row,
  Col,
} from '@pankod/refine-antd'

import { exportToExcel } from 'exportToExcel'

import { IProduct, ITestTrack, ISection } from 'interfaces'
import { CreateProduct } from './create'
import { EditProduct } from './edit'
import { ReactEventHandler, useEffect, useState } from 'react'
import Permissions from 'permissions'
import { useUserContext } from 'context/user'
import productMetaData from 'metadata/products'
import { getProductCount } from 'gql/query'
const { PlusOutlined, ExportOutlined } = Icons
const { Text, Link } = Typography
type Permission = {
  granted?: boolean
}
export const ProductsList: React.FC<IResourceComponentsProps> = () => {
  const [hasPagination, setHasPagination] = useState<any>(true)
  const { show, push } = useNavigation()
  const { mutate: changeProductActive } = useUpdate()
  const [exportData, setExportData] = useState<any[]>()
  const [exportButtonLoading, setExportButtonLoading] = useState<boolean>(false)
  const [productCount, setProductCount] = useState(0)

  const {
    tableProps,
    searchFormProps,
    sorter,
    tableQueryResult,
    setFilters: setProductFilters,
  } = useTable<IProduct>({
    hasPagination,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    initialFilter: [{ field: 'active', operator: 'eq', value: 'true' }],
    metaData: {
      fields: [
        'id',
        'name',
        'description',
        'mycenta_id',
        'created_at',
        'created_by',
        'sections',
        'test_track_ids',
        'total_questions',
        'total_marks',
        'tq',
        'type',
        { test_event: ['name', 'id'] },
        { paper_templates: ['id', 'active'] },
      ],
    },
    queryOptions: { staleTime: Infinity },
    onSearch(data: any) {
      return [{ field: 'name', operator: 'contains', value: `%${data?.name}%` }]
    },
  })
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()
  const [readPermission, setReadPermission] = useState<Permission>({})
  const [createPermission, setCreatePermission] = useState<Permission>({})
  const [editPermission, setEditPermission] = useState<Permission>({})
  const [deletePermission, setDeletePermission] = useState<Permission>({})
  useEffect(() => {
    if (userRole !== undefined) {
      setReadPermission(Permissions.can(userRole).readAny('products'))
      setCreatePermission(Permissions.can(userRole).createAny('products'))
      setEditPermission(Permissions.can(userRole).updateAny('products'))
      setDeletePermission(Permissions.can(userRole).deleteAny('products'))
    }
  }, [userRole])

  //finding product count
  const findProductCount = async () => {
    try {
      const productCountResponse: any = await getProductCount()
      let countOfActiveProduct = productCountResponse?.products_aggregate?.aggregate?.count
      setProductCount(countOfActiveProduct)
    } catch (err) {
      console.log('error on finding product count :', err)
    }
  }

  useEffect(() => {
    if (!readPermission?.granted && readPermission?.granted !== undefined) {
      push('/')
    } else {
      findProductCount()
    }
  }, [readPermission, editPermission])

  const { queryResult, setShowId } = useShow<IProduct>({
    resource: 'products',
    metaData: productMetaData,
  })
  const { data: showQueryResult } = queryResult
  const record = showQueryResult?.data
  const {
    formProps: createFormProps,
    modalProps: createModlaProps,
    show: createShow,
  } = useModalForm({
    resource: 'products',
    action: 'create',
  })
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
    close: editClose,
  } = useModalForm({
    resource: 'products',
    action: 'edit',
    metaData: {
      fields: ['id', 'name', 'description', 'section_ids', 'created_at', 'sections', 'test_track_ids','tq','type'],
    },
  })

  const { tableQueryResult: sectionQueryResult } = useTable<ISection>({
    resource: 'sections',
    metaData: { fields: ['id', 'name'] },
    queryOptions: { staleTime: Infinity },
  })
  const sectionList = sectionQueryResult?.data?.data

  const { tableQueryResult: testTrackQueryResult } = useTable<ITestTrack>({ resource: 'test_tracks', metaData: { fields: ['id', 'name'] } })
  const testTrackList = testTrackQueryResult?.data?.data

  const handleExport = async () => {
    const finalExportData: any[] = []
    tableQueryResult?.data?.data?.forEach((record: IProduct) => {
      const temArr: any[] = []

      let product_id = record?.id
      let product_name = record?.name
      let description = record?.description
      // let total_marks = record?.total_marks
      // let total_questions = record?.total_questions
      let sectionData: string = ''
      let testTrackData: string = ''
      let sectionDataArr: any[] = []

      const noOfSections = record?.sections?.length
      const noOfTestTracks = record?.test_track_ids?.length
      const loopCount = noOfSections > noOfTestTracks ? noOfSections : noOfTestTracks

      for (let i = 0; i < loopCount; i++) {
        let section_id: string | undefined = ''
        let section_name: string | undefined = ''
        let test_track_id: string | undefined = ''
        let test_track_name: string | undefined = ''
        let total_marks: string | undefined = ''
        let questions: string | undefined = ''
        const currentSection: any = record?.sections?.[i]

        if (record?.sections?.[i] !== undefined) {
          const selectedSection = sectionList?.filter((eachSection: any) => eachSection?.id === currentSection?.section_id)[0]
          section_id = selectedSection?.id
          section_name = selectedSection?.name
          total_marks = currentSection?.marks
          questions = currentSection?.no_of_questions
        }
        if (record?.test_track_ids?.[i] !== undefined) {
          const selectedTestTrack = testTrackList?.filter(eachTestTrack => eachTestTrack?.id === record?.test_track_ids?.[i])[0]
          test_track_id = selectedTestTrack?.id
          test_track_name = selectedTestTrack?.name
        }
        finalExportData.push({
          product_id,
          product_name,
          description,
          section_id,
          section_name,
          questions,
          total_marks,
          test_track_id,
          test_track_name,
        })
      }
      // record?.sections?.forEach((section: any, idx) => {
      //   const currentSection = sectionList?.filter(eachSection => eachSection?.id === section?.section_id)[0]
      //   const section_name = currentSection?.name
      //   const marks: string = section?.marks
      //   const section_id: string = section?.section_id
      //   const questions: string = section?.no_of_questions
      //   sectionDataArr.push({ section_name, section_id, marks, questions })
      //   sectionData = `marks:${marks}|section_id:${section_id}|questions:${questions}`
      //   if (record?.sections?.length > idx + 1) sectionData = sectionData + ','
      // })
      // record?.test_track_ids?.forEach((ttid, idx) => {
      //   testTrackData.concat(`${ttid}`)
      //   if (record?.test_track_ids?.length > idx + 1) testTrackData.concat(',')
      // })
    })
    // let testexp = [
    //   { col1: 'aaa', col2: 'bbb' },
    //   { col1: 'aaabbb', col3: 'cccc' },
    // ]

    exportToExcel(finalExportData, `Products_${Math.round(new Date().getTime() / 1000)}.xlsx`)
    // setExportData(finalExportData)
    setExportButtonLoading(false)
  }

  const hideButton = (record: IProduct): boolean => {
    let isTemplateActive = false

    if (record?.test_event !== undefined && record?.paper_templates !== undefined) {
      const shouldHide = record.test_event.length > 0 || record.paper_templates.length > 0
      let templateCount = record?.paper_templates?.filter(template => template?.active === true)
      if (templateCount.length > 0) isTemplateActive = true

      return shouldHide && isTemplateActive
    }
    return false
  }

  // const onChange = (page: number, pageSize?: any): void => {
  //   setCurrent(page)
  // }

  // const searchByName = (value: any) => {
  //   setHasPagination(false)
  //   setProductFilters([
  //     {
  //       field: 'name',
  //       operator: 'contains',
  //       value: `%${value}%`,
  //     },
  //   ])
  // }

  // useEffect(() => {
  //   if (userRole === 'productmanager') {
  //     setProductFilters([{ field: 'created_by', operator: 'eq', value: user?.id }])
  //   }
  // }, [userRole])

  // const { triggerExport, isLoading } = useExport<IProduct>()

  return (
    <>
      <List
        pageHeaderProps={{
          extra: [
            //  <ExportButton onClick={triggerExport} loading={isLoading} />,
            <Button
              icon={<ExportOutlined />}
              onClick={async () => {
                setExportButtonLoading(true)
                await handleExport()
              }}
              loading={exportButtonLoading}
            >
              Export
            </Button>,
            <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
            <CreateButton
              style={{ display: createPermission !== undefined && createPermission?.granted ? 'block' : 'none' }}
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => createShow()}
            />,
          ],
        }}
      >
        <Divider />
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={8} xl={6}>
            <div
              style={{
                boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                padding: '1rem',
                height: '4rem',
                borderRadius: '10px',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <h4>
                Active Products : <span style={{ fontSize: '16px', marginLeft: '5px', fontWeight: 'bold' }}> {productCount}</span>
              </h4>
            </div>
          </Col>
        </Row>
        <Divider />
        {/* <Input.Search
        placeholder="Search By Name"
        onChange={e => {
          if (e.type === 'click') {
            setHasPagination(true)
          }
        }}
        allowClear
        style={{ width: '100%' }}
        onSearch={(value: any) => searchByName(value)}
      /> */}
        <Form {...searchFormProps} style={{ marginBottom: '1rem' }}>
          <Space>
            <Form.Item name="name">
              <Input placeholder="Search by Name" />
            </Form.Item>
            <Button type="primary" icon={<Icons.SearchOutlined />} onClick={searchFormProps.form?.submit}>
              Search
            </Button>
            <Button
              onClick={() => {
                searchFormProps?.form?.setFieldsValue({ name: '' })
                searchFormProps.form?.submit()
              }}
            >
              Clear
            </Button>
          </Space>
        </Form>
        {/* <Divider /> */}

        {readPermission !== undefined && readPermission.granted ? (
          <Table
            {...tableProps}
            // dataSource={tableQueryResult?.data?.data}
            rowKey="id"
            size="small"
            // pagination={{
            //   total: tableQueryResult?.data?.total,
            //   onChange,
            // }}
          >
            <Table.Column
              dataIndex="name"
              title="Name"
              render={(_, record: any) => (
                <ShowButton size="small" type="link" icon={null} recordItemId={record?.id}>
                  <Text
                    style={{
                      width: 200,
                      textAlign: 'left',
                      color: '#6659FF',
                      cursor: 'pointer',
                    }}
                    ellipsis={{ tooltip: record?.name }}
                  >
                    {record?.name}
                  </Text>
                </ShowButton>
              )}
            />
            <Table.Column
              dataIndex="description"
              title="Description"
              render={description => (
                <Text
                  style={{
                    width: 200,
                    textAlign: 'left',
                  }}
                  ellipsis={{ tooltip: description }}
                >
                  {description}
                </Text>
              )}
            />
            <Table.Column
              dataIndex="type"
              title="Product Type"
              render={type => (
                <Text
                  style={{
                    width: 100,
                    textAlign: 'left',
                  }}
                  ellipsis={{ tooltip: type }}
                >
                  {type.toUpperCase()}
                </Text>
              )}
            />
            <Table.Column dataIndex="mycenta_id" title="MyCenta Id" />

            <Table.Column
              dataIndex="created_at"
              title="Created At"
              render={value => <DateField value={value} format="LLL" />}
              defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
              sorter
            />
            <Table.Column<IProduct>
              title="Actions"
              // className={editPermission !== undefined && editPermission?.granted ? 'show' : 'hide'}
              dataIndex="actions"
              render={(_, record) => {
                return record?.created_by === user?.id || userRole === 'admin' ? (
                  <Space>
                    {editPermission !== undefined && editPermission?.granted ? (
                      <EditButton
                        hidden={hideButton(record)}
                        size="small"
                        type="link"
                        icon={null}
                        recordItemId={record.id}
                        onClick={() => {
                          setShowId(record.id)
                          editShow(record.id)
                        }}
                      />
                    ) : null}
                    {deletePermission !== undefined && deletePermission?.granted ? (
                      <Popconfirm
                        title="Are you sure ?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={() => {
                          changeProductActive({ resource: 'products', id: record.id, values: { active: 'false' } })
                          setProductCount(productCount - 1)
                        }}
                      >
                        <Button danger size="small" type="link" icon={null} hidden={hideButton(record)}>
                          Delete
                        </Button>
                      </Popconfirm>
                    ) : null}
                  </Space>
                ) : null
              }}
            />
          </Table>
        ) : null}
        <CreateProduct modalProps={createModlaProps} formProps={createFormProps} findProductCount={findProductCount} />
        <EditProduct modalProps={editModalProps} formProps={editFormProps} close={editClose} record={record} />
      </List>
    </>
  )
}
